module.exports = __webpack_public_path__ + "img/t2-4.0fd01652.png";